export { getIvsClientId } from '@shopee-user/shared-customization-logic/src/ivs/config';

enum IvsEventType {
  Login = 22,
}

export const getLoginIvsEventType = (): number => {
  return IvsEventType.Login;
};
